/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file VideoCallFrame.jsx
 * @author Daniel Aguirre
 * @description Vide call frame page
 */

// Dependencies
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppCardLayout from '@nephro/components/AppCardLayout';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import i18next from 'i18next';
import { getStorageItem } from 'commons/helpers/storage-helper';

function VideoCallsFrameView({ parameterActions }) {
  const { getMultipleParameterByKey } = parameterActions;
  const { t: translate } = useTranslation();
  const { language } = i18next;
  const [currentLanguage, setCurrentLanguage] = useState(language);
  const [zoomApiKey, setZoomApiKey] = useState(null);
  const [zoomApiSecret, setZoomApiSecret] = useState(null);
  const history = useHistory();
  const {
    state: { meetingId }
  } = useLocation();

  const onGetParameter = async (_, response) => {
    if (response) {
      const [key, secret] = response;
      setZoomApiKey(key.data.param_value);
      setZoomApiSecret(secret.data.param_value);
    }
  };

  useEffect(async () => {
    if (currentLanguage !== i18next.language) {
      setCurrentLanguage(i18next.language);
      history.go(0);
    }
    const parameterKeys = ['zoomApiKey', 'zoomApiSecret'];
    await getMultipleParameterByKey({ parameterKeys }, onGetParameter);
  }, [translate]);

  const onLoadIframe = async (event) => {
    const pathnameiFrame = event.target.contentWindow.location.pathname;
    if (!pathnameiFrame.includes('/main/videocall/')) {
      const isPatient = await getStorageItem('isPatient');
      // eslint-disable-next-line no-unused-expressions
      isPatient
        ? history.push('/main/appointments')
        : history.push('/main/scheduled-appointments');
    }
  };

  return (
    <AppCardLayout>
      <div className="h-full p-3">
        <iframe
          onLoad={onLoadIframe}
          id="video-call-frame"
          width="100%"
          height="100%"
          src={`/main/videocall/${meetingId}/${zoomApiKey}/${zoomApiSecret}`}
          title="VideoCall"
          className="rounded-lg"
          sandbox="allow-top-navigation allow-same-origin allow-scripts"
        />
        {/*
          TODO:
          Add custom contrls
        */}
      </div>
    </AppCardLayout>
  );
}

/**
 * @name PageHeader.propTypes
 * @type { Object }
 */
VideoCallsFrameView.propTypes = {
  parameterActions: PropTypes.shape({
    getMultipleParameterByKey: PropTypes.func.isRequired
  }).isRequired
};

export default VideoCallsFrameView;
